import React from "react";

export const Story = () => {
  return (
    <section className={"flex story"} id="story">
      <h2 className="font1 catch " style={{ color: "white" }}>
        Story Overview
      </h2>
      <div>
        <p
          className="story-text"
          style={{
            padding: "10%",
            backgroundColor: "transparent",
          }}
        >
          In a world covered in miasma, a floating castle is the last refuge for
          mankind. The earth is scarred with creatures altered by the plague
          while Welkin Castle is isolated in the sky from the horrors below.
          <br />
          <br />
          Lucien, a charismatic politician protected within the castle’s walls,
          discovers an ancient book where he learns of the Exemplars, weapons
          that can turn into sentient soldiers. He joins forces with Rowena, a
          revenant determined to find a way to come back to life to raise her
          living son, and the two reluctantly make a pact to overthrow the mad
          tyrant controlling Welkin.
        </p>
      </div>
    </section>
  );
};
